import axios from "axios";

class Profile {
    get() {
        return axios.get('/api/v1/client/profile');
    }

    update(data) {
        return axios.put('/api/v1/client/profile', data)
    }
}

export default Profile